/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReleaseStatus } from './ReleaseStatus';
import {
    ReleaseStatusFromJSON,
    ReleaseStatusFromJSONTyped,
    ReleaseStatusToJSON,
    ReleaseStatusToJSONTyped,
} from './ReleaseStatus';

/**
 * The LAUNCH, not the thing being launched — a date and a phase.
 * 
 * Everything this once carried (title, art, tagline, synopsis, store
 * link, trailer, videos, modes, platforms, category identity) is a Drop
 * field, because a shipped title and a franchise have all of it and no
 * release at all. Sending `release` at all is what says "a launch is
 * attached"; omitting it is the normal case.
 * 
 * @export
 * @interface DropReleaseBody
 */
export interface DropReleaseBody {
    /**
     * Epoch ms. Absent while announced with no date.
     * @type {number}
     * @memberof DropReleaseBody
     */
    releaseDate?: number;
    /**
     * 
     * @type {ReleaseStatus}
     * @memberof DropReleaseBody
     */
    status?: ReleaseStatus;
}



/**
 * Check if a given object implements the DropReleaseBody interface.
 */
export function instanceOfDropReleaseBody(value: object): value is DropReleaseBody {
    return true;
}

export function DropReleaseBodyFromJSON(json: any): DropReleaseBody {
    return DropReleaseBodyFromJSONTyped(json, false);
}

export function DropReleaseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropReleaseBody {
    if (json == null) {
        return json;
    }
    return {
        
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
        'status': json['status'] == null ? undefined : ReleaseStatusFromJSON(json['status']),
    };
}

export function DropReleaseBodyToJSON(json: any): DropReleaseBody {
    return DropReleaseBodyToJSONTyped(json, false);
}

export function DropReleaseBodyToJSONTyped(value?: DropReleaseBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'releaseDate': value['releaseDate'],
        'status': ReleaseStatusToJSON(value['status']),
    };
}

